// Words for a withdrawal's refund, shared by the Withdrawals panel, Entries "Operations
// in progress", Action Logs and waiting-list results: one labels module, so the same
// reason never reads two ways (CP lessons, 2026-10-01).
export const refundReasons = {
  REFUND_CURRENCY_UNVERIFIED: "The original charge is not proven in the current wallet currency. No refund amount has been reserved or credited; financial reconciliation is required.",
  PAYMENT_NOT_FOUND: "The original payment could not be identified. No refund has been assumed.",
  ALREADY_WITHDRAWN: "An earlier withdrawal payment exists. The financial result requires reconciliation.",
  REFUND_ALREADY_CLAIMED: "The source amount was already reserved for a reversal; wallet credit is not proven.",
  ZERO_SOURCE_CHARGE: "The original Sportya charge is confirmed as zero.",
  INVALID_SOURCE_CHARGE: "The original charge cannot be validated.",
  WALLET_REFUND_FAILED: "The wallet credit is not confirmed. Financial review is still required.",
  PAYMENT_RECONCILIATION_FAILED: "The payment record needs review.",
}
// A refund reason with no label above still reads as what it asks of the admin.
export const REFUND_REVIEW_FALLBACK = "The refund needs financial review."

// A SuperAdmin's Refund Resolution (API ADR 0014): a decision, not a credit.
export const RESOLVED_BY_SUPERADMIN = "Refund resolved by SuperAdmin"
export const resolutionOutcomes = { noRefundOwed: "No refund owed", refundedElsewhere: "Refunded outside this flow" }
export const resolutionText = resolution => [resolutionOutcomes[resolution?.outcome] || "Decision not recorded", resolution?.note].filter(Boolean).join(" · ")
export const resolutionSuperseded = "A refund was later confirmed automatically. Check that the payer was not refunded twice."
